@if (isBlocked()) {
  <ac-card>
    <ac-card-header (close)="close('header')">
      <div>
        <span class="ac-headline-sm" [style.line-height.px]="32">Additional Review Required</span>
        <div class="ac-body-md ac-label">
          Your document requires further review from our compliance team. You will receive an update to your email when this review is complete.
        </div>
      </div>
    </ac-card-header>
    <ac-card-content>
      <div class="ac-flex ac-flex-col ac-gap-lg ac-ctr">
        <app-lottie-animation [size]="132" path="payments_blocked" [loop]="false" />
        <button
          mat-flat-button
          (click)="onVerifyLater(); $event.preventDefault()"
          [style.width.%]="100"
          class="ac-btn-lg ac-secondary"
        >
          Continue with Redemption
        </button>


        <div class="ac-body-sm ac-label ac-text-ctr">
          Please note your redemption will be on hold until your document has been verified by our compliance team.
        </div>
      </div>
    </ac-card-content>
  </ac-card>
}
@else if (!inquiryCreated()) {
  <ac-card>
    <ac-card-content>
      @if (viewMode() === 'verify') {
        <div class="document-verification-dialog ac-flex ac-flex-ctr ac-flex-col ac-gap-lg">
          <div class="ac-flex ac-sp-btw">
            <div [style.width.px]="46"></div>
            <img
              class="payment-method-verification-image"
              [width]="100"
              [height]="100"
              [src]="('cdnUrl' | env) + '/images/payment_method_verification.webp'"
              alt="payment-method-verification-image"
            />
            <button
              (click)="close()"
              mat-icon-button
              class="close-button ac-icon-btn-sm"
              aria-label="Close"
            >
              <ac-icon iconKey="hr:xmark" [size]="20"></ac-icon>
            </button>
          </div>
          <div class="ac-flex ac-flex-col ac-gap-sm ac-just-ctr">
            <div class="ac-headline-sm ac-text-ctr">
              Additional Verification Required
            </div>
            <div class="ac-body-md ac-label">
              To continue, upload an official PDF statement from the bank or credit card company associated with one of the cards you used to purchase Gold Coins.
            </div>
            @if (creditCardPaymentMethods()?.length) {
              <div class="document-verification-dialog__entity-hint ac-flex ac-flex-col ac-gap-sm" [style.margin-top.px]="0">
                <div class="ac-body-sm ac-primary ac-warning ac-text-ctr">
                  The statement must be associated with one of the following cards
                </div>
                <div class="document-verification-dialog__payment-pills">
                  @for (pm of creditCardPaymentMethods(); track pm.payment_method_id) {
                    <div class="document-verification-dialog__payment-pill">
                      @switch (pm.metadata?.cardType) {
                        @case ('VISA') {
                          <ac-icon iconKey="payment:visa" [size]="12" />
                        }
                        @case ('MSTR') {
                          <ac-icon iconKey="payment:mastercard" [size]="12" />
                        }
                        @case ('AMEX') {
                          <ac-icon iconKey="payment:amex" [size]="12" />
                        }
                        @case ('DISC') {
                          <ac-icon iconKey="payment:discover" [size]="12" />
                        }
                        @default {
                          <ac-icon iconKey="payment:debit_credit_card" [size]="12" />
                        }
                      }
                      <span class="ac-title-sm">{{ pm.metadata?.last4 }}</span>
                    </div>
                  }
                </div>
              </div>
            }
          </div>
          <div class="document-verification-dialog__acks ac-flex ac-flex-col ac-gap-md">
            <mat-checkbox
              class="document-verification-dialog__ack"
              [checked]="acknowledged()"
              (change)="acknowledged.set($event.checked)"
            >
              <span class="ac-body-md">
                I understand that an official PDF statement needs to be downloaded from the associated bank or credit card company of one of the cards I used for payment. If I don't do this, my redemption will be rejected.
              </span>
            </mat-checkbox>
          </div>
          <div class="ac-flex ac-flex-col ac-gap-md ac-flex-ctr" [style.width.%]="100">
            <button
              mat-flat-button
              (click)="startVerification(); $event.preventDefault()"
              [loading]="startVerificationLoading()"
              [disabled]="startVerificationDisabled()"
              class="ac-btn-lg"
              [style.width.%]="100"
            >
              Continue
            </button>
            <button
              type="button"
              class="document-verification-dialog__example-link ac-flex ac-gap-xs ac-flex-ctr"
              (click)="showExample()"
            >
              <ac-icon iconKey="hr:document" [size]="16"></ac-icon>
              <span class="ac-title-sm">What is an official statement?</span>
            </button>
          </div>
        </div>
      } @else {
        <div class="document-verification-dialog ac-flex ac-flex-ctr ac-flex-col ac-gap-lg">
          <div class="ac-flex ac-sp-btw">
            <button
              (click)="hideExample()"
              mat-icon-button
              class="back-button ac-icon-btn-sm"
              aria-label="Back"
            >
              <ac-icon iconKey="hr:arrow_left" [size]="20"></ac-icon>
            </button>
            <img
              class="payment-method-verification-image"
              [width]="100"
              [height]="100"
              [src]="('cdnUrl' | env) + '/images/payment_method_verification.webp'"
              alt="payment-method-verification-image"
            />
            <button
              (click)="close()"
              mat-icon-button
              class="close-button ac-icon-btn-sm"
              aria-label="Close"
            >
              <ac-icon iconKey="hr:xmark" [size]="20"></ac-icon>
            </button>
          </div>
          <div class="ac-flex ac-flex-col ac-gap-sm ac-just-ctr">
            <div class="ac-headline-sm ac-text-ctr">Statement Example</div>
            <div class="ac-body-md ac-label">
              All banks and credit card companies provide monthly statements. You can usually find yours by logging into your bank or credit card company's app or website and looking under 'Statements' or 'Documents.' If you paid with a credit card, make sure you download the statement from your credit card account &mdash; not your checking account.
            </div>
          </div>
          <img
            class="document-verification-dialog__example-image"
            [src]="('cdnUrl' | env) + '/images/sample_statement.webp'"
            alt="Sample bank or credit card statement"
          />
          <button
            mat-flat-button
            (click)="hideExample(); $event.preventDefault()"
            class="ac-btn-lg"
            [style.width.%]="100"
          >
            Go Back
          </button>
        </div>
      }
    </ac-card-content>
  </ac-card>
}
@else {
  <ac-card>
    @if (status() === 'approved') {
      <ac-card-header (close)="close()">
        <div>
          <span class="ac-headline-sm" [style.line-height.px]="32">
            Verification complete
          </span>
          <div class="ac-body-md ac-label">
            Your account has successfully been verified.
          </div>
        </div>
      </ac-card-header>
    }
    @if (status() === 'rejected') {
      <ac-card-header (close)="close()">
        <div>
          <span class="ac-headline-sm" [style.line-height.px]="32">Verification failed</span>
          <div class="ac-body-md ac-label">
            Your document verification has failed.
          </div>
        </div>
      </ac-card-header>
    }
    @if (status() === 'pending') {
      <ac-card-header (close)="close()">
        <div>
          <span class="ac-headline-sm" [style.line-height.px]="32">Verification in progress</span>
          <div class="ac-body-md ac-label">
            Your verification attempt is currently processing. You will receive a notification when your verification is complete.
          </div>
        </div>
      </ac-card-header>
    }

    <ac-card-content>
      <div class="document-verification-dialog ac-flex ac-flex-col ac-gap-lg ac-ctr">
        @switch (status()) {
          @case ('approved') {
            <app-lottie-animation [size]="132" path="payments_complete" [loop]="false" />
          }
          @case ('rejected') {
            <ac-icon iconKey="payment:fail" [size]="132" />
            <button
              mat-flat-button
              (click)="retryVerification(); $event.preventDefault()"
              [style.width.%]="100"
              class="ac-btn-lg"
              [loading]="startVerificationLoading()"
            >
              Try again
            </button>
            <button
              mat-flat-button
              (click)="onVerifyLater(); $event.preventDefault()"
              [style.width.%]="100"
              class="ac-btn-lg ac-secondary"
            >
              I'll verify another time
            </button>
          }
          @default {
            <app-lottie-animation [size]="132" path="payments_pending" [loop]="true" />
          }
        }
      </div>
    </ac-card-content>
  </ac-card>
}
